/** @format */

export type HomrBadgeBoxShadowOptions = 'true' | '';
export type HomrButtonStyleOptions = 'primary' | 'secondary' | 'tertiary' | 'marketing';
export type HomrMobileTextBoxVerticalPositionOptions = 'bottom' | 'center';
export type HomrTextBlockBackgroundOptions = 'true' | 'false';
export type HomrTextBoxPositionOptions =
  | 'left'
  | 'center'
  | 'right'
  | 'none'
  | 'inlineRight'
  | 'inlineLeft';
export type HomrTextColorOptions = 'light' | 'dark';
